import {css} from 'lit';
export const styles = css`:host{width:100%;--fp-button-display:block;--fp-button-justify:start}`;
export default styles;
